/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_bmr_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculate your basal metabolic rate and daily calorie needs (TDEE).`)
};

const es_bmr_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcula tu tasa metabólica basal y tus necesidades calóricas diarias (GEDT).`)
};

const de_bmr_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berechne deinen Grundumsatz und deinen täglichen Kalorienbedarf (TDEE).`)
};

const nl_bmr_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bereken je basaal metabolisme en dagelijkse caloriebehoefte (TDEE).`)
};

const fr_bmr_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculez votre métabolisme de base et vos besoins caloriques quotidiens (TDEE).`)
};

const it_bmr_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcola il tuo metabolismo basale e il fabbisogno calorico giornaliero (TDEE).`)
};

const pt_br2_bmr_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcule sua taxa metabólica basal e a necessidade calórica diária (GET).`)
};

const pt_bmr_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcule a sua taxa metabólica basal e as necessidades calóricas diárias (TDEE).`)
};

const ja_bmr_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`基礎代謝量と1日の消費カロリー(TDEE)を計算します。`)
};

const zh_bmr_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`计算你的基础代谢率和每日热量需求（TDEE）。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bmr_tool_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bmr_tool_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("bmr_tool_description", locale)
	if (locale === "en") return en_bmr_tool_description(inputs)
	if (locale === "es") return es_bmr_tool_description(inputs)
	if (locale === "de") return de_bmr_tool_description(inputs)
	if (locale === "nl") return nl_bmr_tool_description(inputs)
	if (locale === "fr") return fr_bmr_tool_description(inputs)
	if (locale === "it") return it_bmr_tool_description(inputs)
	if (locale === "pt-BR") return pt_br2_bmr_tool_description(inputs)
	if (locale === "pt") return pt_bmr_tool_description(inputs)
	if (locale === "ja") return ja_bmr_tool_description(inputs)
	return zh_bmr_tool_description(inputs)
};